export default "__VITE_ASSET__Cvv3jX2q__"